


















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { BSpinner } from 'bootstrap-vue'
import AudioRecorder, { RecordedAudio } from '@/libs/speech/recorder'

@Component({ name: 'dictation-button', components: { BSpinner } })
export default class DictationButton extends Vue {
  // Fonction de transcription injectée par le parent (découple ce composant de l'API chantiers).
  @Prop({ required: true }) transcribe!: (audio: RecordedAudio) => Promise<string>;

  private static readonly MAX_SECONDS = 180; // cap ~3 min

  supported = AudioRecorder.isSupported();

  isRecording = false;

  isTranscribing = false;

  errorMessage = '';

  elapsed = 0;

  starting = false;

  private recorder: AudioRecorder | null = null;

  private timer: number | null = null;

  private destroyed = false;

  get buttonLabel(): string {
    if (this.isTranscribing) return 'Transcription…'
    return this.isRecording ? 'Arrêter' : 'Dicter'
  }

  get elapsedLabel(): string {
    const m = Math.floor(this.elapsed / 60)
    const s = this.elapsed % 60
    return `● ${m}:${s.toString().padStart(2, '0')}`
  }

  beforeDestroy() {
    this.destroyed = true
    this.clearTimer()
    if (this.recorder) this.recorder.dispose()
  }

  toggle() {
    if (this.isTranscribing) return
    if (this.isRecording) this.stopAndTranscribe()
    else this.startRecording()
  }

  private async startRecording() {
    // Garde de réentrance : un 2e clic pendant la demande de permission ne doit pas
    // créer un second AudioRecorder (et fuiter un micro non libéré).
    if (this.starting || this.recorder) return
    this.starting = true
    this.errorMessage = ''
    this.elapsed = 0
    const recorder = new AudioRecorder()
    try {
      await recorder.start()
      // Symétrique à stopAndTranscribe : si le composant a été détruit pendant la demande de
      // permission (await), libérer le micro local et ne pas démarrer de timer orphelin.
      if (this.destroyed) { recorder.dispose(); return }
      this.recorder = recorder
      this.isRecording = true
      this.timer = window.setInterval(() => {
        this.elapsed += 1
        if (this.elapsed >= DictationButton.MAX_SECONDS) this.stopAndTranscribe()
      }, 1000)
    } catch (e) {
      recorder.dispose()
      this.errorMessage = e && (e as any).name === 'NotAllowedError'
        ? 'Accès au micro refusé. Autorisez le microphone dans le navigateur.'
        : "Impossible de démarrer l'enregistrement."
    } finally {
      this.starting = false
    }
  }

  private async stopAndTranscribe() {
    this.clearTimer()
    if (!this.recorder || !this.isRecording) return
    this.isRecording = false
    this.isTranscribing = true
    try {
      const audio = await this.recorder.stop()
      if (this.destroyed) return
      if (!audio.blob || audio.blob.size === 0) {
        this.errorMessage = 'Aucun son capté. Vérifiez le micro et réessayez.'
        return
      }
      const text = await this.transcribe(audio)
      if (this.destroyed) return
      if (text && text.trim()) {
        // espace final pour ne pas coller au texte suivant
        this.$emit('final-text', `${text.trim()} `)
      } else {
        this.errorMessage = 'Aucun texte reconnu. Réessayez en parlant plus distinctement.'
      }
    } catch (e) {
      if (!this.destroyed) this.errorMessage = 'La transcription a échoué. Réessayez.'
    } finally {
      this.isTranscribing = false
      this.recorder = null
    }
  }

  private clearTimer() {
    if (this.timer !== null) { window.clearInterval(this.timer); this.timer = null }
  }
}
